export const primaryColor = "#125F3F";
export const primaryHover = "#125F3F90";

export const shadowColor = "#125F3F";
export const errorRed = "#ff5757";